import "core-js/stable";
import "regenerator-runtime/runtime";
import "./assets/css/axa-design.css";
import "./assets/css/style.css";
import "./assets/css/icons.css";
import "./assets/css/fonts.css";
import "./assets/css/home.css";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Route } from "react-router-dom";
import App from "./App";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";
import interceptor from "./services/Network";
import axios from "axios";
import { API_ROOT } from "./api-config";
import store from "./Store";
import { OidcProvider } from "redux-oidc";
import userManager from "./helpers/UserManagerHelper";
import TelemetryProvider from "./logging/TelemetryProvider";
import { Layouts } from "./constants/Constants";
import { getLayout } from "./layout/Layout";
import { CookiesProvider } from "react-cookie";
import StubUserSelectorEntryPoint from "./stubs/StubUserSelectorEntryPoint";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

axios.defaults.withCredentials = true;
axios.defaults.baseURL = API_ROOT;

if (getLayout() === Layouts.HOL) {
  import("../src/assets/css/hol.css").then(m => {
    if (document.documentMode) {
      import("../src/assets/css/ie-footer-min-hol.css");
    }
  });
}

if (document.documentMode) {
  import("./assets/css/ie-footer-min.css");
}

unregisterServiceWorker();
interceptor.setupInterceptors();

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <BrowserRouter basename={baseUrl}>
          <StubUserSelectorEntryPoint />
          <TelemetryProvider
            instrumentationKey={
              window.axa && window.axa.ai && window.axa.ai.instrumentationKey
            }
          >
            <Route component={App} />
          </TelemetryProvider>
        </BrowserRouter>
      </OidcProvider>
    </Provider>
  </CookiesProvider>,
  rootElement
);
